import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {Procedure} from "../../domain/procedure";
import {VisitServiceService} from "../../providers/visit-service-service";

/*
  Generated class for the Visit page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-visit',
  templateUrl: 'visit.html'
})
export class VisitPage {

  visit_id: any;
  happened_on: any;
  procedures: Procedure[] = []

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private visitServiceService: VisitServiceService) {
     this.visit_id = navParams.get("visit_id");
     this.happened_on = navParams.get("happened_on");
  }

  ngOnInit() {

    this.visitServiceService.getVisitServices(this.visit_id)
            .subscribe(services => {
                this.procedures = services
              }
            )

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VisitPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/visit/visit.ts